var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcInputField',{attrs:{"type":"email","required":true,"model-value":_vm.recipient,"label-outside":true,"aria-label":_vm.t('mail', 'Recipient'),"placeholder":_vm.t('mail', 'name@example.org')},on:{"update:model-value":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }